import ModalPlan from '@ui/Modal/Plan/component'
import dataLayer from 'assets/core/js/module/dataLayer'
import type { ModalType } from '@ui/Modal/component'

export default function (): void {
  let modal: ModalType | undefined

  document.addEventListener('click', (e) => {
    const el = e.target as HTMLElement

    if (el.classList.contains('result-accommodation__plan-button')) {
      e.stopPropagation()
      e.preventDefault()

      const id = el.getAttribute('data-modal-target')

      if (!id) {
        return
      }

      if (!modal) {
        modal = ModalPlan(id, {
          onOpen: () => {
            dataLayer.pushInLayer(window.coreGtmId, {
              event: dataLayer.events.ACCOMMODATION_PLAN_VIEW,
            })
          },
        })
        modal?.open()
      }
    }
  })
}
